"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWorkspaceOutput = instanceOfWorkspaceOutput;
exports.WorkspaceOutputFromJSON = WorkspaceOutputFromJSON;
exports.WorkspaceOutputFromJSONTyped = WorkspaceOutputFromJSONTyped;
exports.WorkspaceOutputToJSON = WorkspaceOutputToJSON;
var Metadata_1 = require("./Metadata");
var Workspace_1 = require("./Workspace");
/**
 * Check if a given object implements the WorkspaceOutput interface.
 */
function instanceOfWorkspaceOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function WorkspaceOutputFromJSON(json) {
    return WorkspaceOutputFromJSONTyped(json, false);
}
function WorkspaceOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Workspace_1.WorkspaceFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function WorkspaceOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Workspace_1.WorkspaceToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
